import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

const TIME_SLOTS = [
  { v: "morning", l: "Mattina (08:30–12:30)" },
  { v: "afternoon", l: "Pomeriggio (14:30–19:00)" },
  { v: "any", l: "Qualsiasi orario" },
];

export default function BookingForm({ defaultSection = "officina" }) {
  const today = new Date().toISOString().slice(0, 10);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    date: "",
    slot: "morning",
    request: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", {
        name: `${form.firstName} ${form.lastName}`.trim(),
        email: form.email,
        phone: form.phone,
        subject: `Prenotazione appuntamento — ${form.date} ${TIME_SLOTS.find((s) => s.v === form.slot)?.l || form.slot}`,
        message: form.request || `Prenotazione ${form.date} (${form.slot}).`,
        section: defaultSection,
      });
      toast.success("Richiesta inviata. Ti contatteremo per confermare.");
      setForm({ firstName: "", lastName: "", phone: "", email: "", date: "", slot: "morning", request: "" });
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Invio fallito");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      id="prenota"
      onSubmit={submit}
      className="card-flat p-6 md:p-10 space-y-5"
      data-testid="booking-form"
    >
      <div>
        <span className="label-eyebrow text-[color:var(--nsa-orange)]">Mettiti in contatto con noi</span>
        <h3 className="font-display text-3xl md:text-4xl uppercase tracking-tight mt-2">
          Prenota un appuntamento
        </h3>
        <p className="text-gray-600 mt-2">Compila il modulo, ti confermeremo l'appuntamento entro 24 ore lavorative.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <Field label="Nome*" name="firstName" value={form.firstName} onChange={onChange} required tid="bk-firstname" />
        <Field label="Cognome*" name="lastName" value={form.lastName} onChange={onChange} required tid="bk-lastname" />
        <Field label="Telefono*" name="phone" value={form.phone} onChange={onChange} required tid="bk-phone" />
        <Field label="Email*" name="email" type="email" value={form.email} onChange={onChange} required tid="bk-email" />
        <Field label="Data desiderata*" name="date" type="date" min={today} value={form.date} onChange={onChange} required tid="bk-date" />
        <div>
          <label className="label-eyebrow text-gray-500 block mb-2">Fascia oraria desiderata*</label>
          <select
            name="slot"
            value={form.slot}
            onChange={onChange}
            className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3 bg-white"
            data-testid="bk-slot"
          >
            {TIME_SLOTS.map((s) => <option key={s.v} value={s.v}>{s.l}</option>)}
          </select>
        </div>
      </div>

      <div>
        <label className="label-eyebrow text-gray-500 block mb-2">Richiesta</label>
        <textarea
          name="request"
          value={form.request}
          onChange={onChange}
          rows={5}
          placeholder="Descrivici cosa ti serve: tagliando, riparazione, revisione, ecc."
          className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3"
          data-testid="bk-request"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="bg-gray-900 text-white label-eyebrow px-6 py-4 inline-flex items-center gap-3 disabled:opacity-60 hover:bg-black"
        data-testid="bk-submit"
      >
        {loading ? "Invio..." : "INVIA RICHIESTA"} <Send size={16} />
      </button>
    </form>
  );
}

function Field({ label, tid, ...props }) {
  return (
    <div>
      <label className="label-eyebrow text-gray-500 block mb-2">{label}</label>
      <input
        {...props}
        className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3 bg-white"
        data-testid={tid}
      />
    </div>
  );
}
